













import store from '@/store';
import Global from '@/common/global.js'

export default
  name: 'TextArea'

  props:
    # value
    value:
      type: String
      default: null
    # Props名
    name:
      type: String
      default: ''
    # maxlength
    maxlength:
      type: Number
      default: 20000
    # placeholder
    placeholder:
      type: String
      default: ''
    # リードオンリー
    readonly:
      type: Boolean
      default: false
    # GROUP
    group:
      type: String
      default: null
    # コントロール配列
    index:
      type: Number
      default: null
    noStore:
      type: Boolean
      default: false
    highHeight:
      type: Boolean
      default: false

  watch: {
    value: (v) ->
      @_saveStore(v)
      @v = v
  }

  data: () ->
    v: @value

  mounted: () ->
    if (!Global.hasGroupIndexValue(@group, @index, @name))
      @_saveStore('')

#  updated: () ->
#    @_saveStore(@val)

  computed: {
    val: () ->
      return @v

    isDetailChange: () ->
      if !@noStore
        @v = Global.getGroupIndexValue(@group, @index, @name)
        return store.getters.isSetDetail
      return ''
  }

  methods: {
    change: (e) ->
      @_saveStore(e.target.value)
      @$emit('change', {val: e.target.value, name: @name, index: @index})
    click: (e) ->
      @$emit('click')
    _saveStore: (value) ->
      if !@noStore
        store.dispatch('setPostParam', {label: @name, value: value, index: @index, group: @group})
  }
